/* eslint-disable no-unused-vars */
/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js";

export default {
  getListBonus({ commit }, { query }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`teachers/bonus?${new URLSearchParams(query)}`)
        .then((response) => {
          commit("SET_LIST_BONUS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  createBonus({ commit }, { payload }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`teachers/bonus`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateBonus({ commit }, { payload }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`teachers/bonus/1`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // Bonus setting of teacher
  getBonusSettingTeacher({ commit }, { query }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`teachers/bonus-setting?${new URLSearchParams(query)}`)
        .then((response) => {
          commit("SET_BONUS_SETTING_TEACHER", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  createBonusSettingTeacher({ commit }, { payload }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`teachers/bonus-setting`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateBonusSettingTeacher({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`teachers/bonus-setting/${id}`, payload)
        .then((response) => {
          commit("UPDATE_BONUS_SETTING_TEACHER", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
